import Container from "@material-ui/core/Container";
import BuccaneerHeader from "../components/Home/BuccaneerHeader";
import SendAndSell from "../components/bermuda/SendAndSell";
import Description from "../components/bermuda/Description";
import BermudaTopContainer from "../components/bermuda/BermudaTopContainer";
import styled, { css } from "styled-components";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../components/Loader";
import { useTranslation } from "react-i18next";
import Tooltip from "../components/Tooltip";
import { useState } from "react";
import { useStateContext } from "../providers/StateProvider";

interface Props {
  connect: () => void;
  setIsHide: (e: any) => void;
  killSession: () => void;
  isHide: boolean;
  connected: boolean;
  address: string;
  chainId: number;
  ballance: number | string;
  onPrivateSend: (
    amount: string,
    receiver: string,
    salt: string,
    isGlass: boolean
  ) => Promise<boolean>;
  onGaslessSend: (amount: string, receiver: string, salt: string) => void;
  onChangeInstructed: (state: boolean) => Promise<boolean>;
  onChangedePrivatize: (state: boolean) => Promise<boolean>;
  showModal: boolean;
  decoyVal: boolean;
  privateVal: boolean;
  modalText: string;
  decrypt: () => void;
  getEarnText: (address: string) => Promise<string>;
}

interface ModalProps {
  show: boolean;
}

const DarkBackground = styled.div<ModalProps>`
  display: none; /* Hidden by default */
  position: fixed; /* Stay in place */
  z-index: 900; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  background-color: rgba(0, 0, 0, 0.5); /* Black w/ opacity */
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.show &&
    css`
      display: flex; /* show */
    `}
`;

const SModalContainer = styled.div`
  width: 100%;
  position: relative;
  word-wrap: break-word;
`;

const SContainer = styled.div`
  height: 100%;
  min-height: 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  word-break: break-word;
`;

const SModalParagraph = styled.p`
  color: white;
  margin-top: 30px;
  font-size: 18px;
`;

const BermudaScreen = (props: Props) => {
  const { t } = useTranslation();
  const { showTooltip, isRevealTooltip, setShowTooltip } = useStateContext();

  return (
    <Container maxWidth="lg">
      <DarkBackground show={props.showModal}>
        <SModalContainer>
          <SContainer>
            <Loader />
            <SModalParagraph>{props.modalText}</SModalParagraph>
          </SContainer>
        </SModalContainer>
      </DarkBackground>
      <BuccaneerHeader
        connect={props.connect}
        isHide={props.isHide}
        setIsHide={(e: any) => props.setIsHide(e)}
        connected={props.connected}
        address={props.address}
        chainId={props.chainId}
        killSession={props.killSession}
      />
      <BermudaTopContainer
        isHide={props.isHide}
        ballance={props.ballance}
        onChangeInstructed={props.onChangeInstructed}
        decoyVal={props.decoyVal}
        onChangedePrivatize={props.onChangedePrivatize}
        privateVal={props.privateVal}
        decrypt={props.decrypt}
      />

      <SendAndSell
        onPrivateSend={props.onPrivateSend}
        onGaslessSend={props.onGaslessSend}
        getEarnText={props.getEarnText}
      />

      <Tooltip
        text={isRevealTooltip ? t("RevealTooltip") : t("BermudaTooltip")}
        show={showTooltip}
        setVisible={setShowTooltip}
      />

      <Description title={t("NeedToEnterSalt")} />
    </Container>
  );
};

export default BermudaScreen;
